import request from "@/utils/request"
import { ConstConfig } from "@/constants"

export function getMatchGameTeamStartingList(params) {
  return request({
    baseURL: process.env.VUE_APP_PASS_API,
    url: ConstConfig.apiPath + '/GetBMMatchGameTeamStartingList.json',
    method: 'GET',
    params
  })
}

export function updateMatchGameTeamStartingList(params, data) {
  return request({
    baseURL: process.env.VUE_APP_PASS_API,
    url: ConstConfig.apiPath + '/UpdateBMMatchGameTeamStartingList.json',
    method: 'POST',
    params,
    data
  })
}
export function updateClothesColors(params, data) {
  return request({
    baseURL: process.env.VUE_APP_PASS_API,
    url: ConstConfig.apiPath + '/UpdateBMMatchGameTeamClothesColors.json',
    method: 'POST',
    params,
    data
  })
}
export function updateOfficerBePresentList(params, data) {
  return request({
    baseURL: process.env.VUE_APP_PASS_API,
    url: ConstConfig.apiPath + '/UpdateBMMatchGameTeamOfficerBePresentList.json',
    method: 'POST',
    params,
    data
  })
}

export function getGameDetail(params) {
  return request({
    baseURL: process.env.VUE_APP_PASS_API,
    url: ConstConfig.apiPath + '/GetBMGameDetail.json',
    method: 'GET',
    params
  })
}
export function getTeamClothesColors(params) {
  return request({
    baseURL: process.env.VUE_APP_PASS_API,
    url: ConstConfig.apiPath + '/GetBMMatchGameTeamClothesColors.json',
    method: 'GET',
    params
  })
}
export function getGameTeamOfficerList(params) {
  return request({
    baseURL: process.env.VUE_APP_PASS_API,
    url: ConstConfig.apiPath + '/GetBMMatchGameTeamOfficerList.json',
    method: 'GET',
    params
  })
}

export function getPlayerRosterInfo(params) {
  return request({
    baseURL: process.env.VUE_APP_PASS_API,
    url: ConstConfig.apiPath + '/GetPlayerRollCallInformation.json',
    method: 'GET',
    params
  })
}

export function updatePlayerRosterInfo(params, data) {
  return request({
    baseURL: process.env.VUE_APP_PASS_API,
    url: ConstConfig.apiPath + '/UpdatePlayerRollCallStatus.json',
    method: 'POST',
    params,
    data
  })
}
export function updateOfficerRollCallStatus(params, data) {
  return request({
    baseURL: process.env.VUE_APP_PASS_API,
    url: ConstConfig.apiPath + '/UpdateOfficerRollCallStatus.json',
    method: 'POST',
    params,
    data
  })
}

export function getGameUserRole(params) {
  return request({
    url: '/bmmatch/GetBMGameUserRole',
    method: 'GET',
    params
  })
}
export function getBMGameLockListOnStage(params) {
  return request({
    url: '/bmmatch/GetBMGameLockListOnStage',
    method: 'GET',
    params
  })
}
export function updateBMGameLockListOnStage(params) {
  return request({
    url: '/bmmatch/AdminUpdateBMGameLockListOnStage',
    method: 'GET',
    params
  })
}

export function getGameEventsByPlayer(params) {
  return request({
    url: '/bmmatch/GetBMGameEventsByPlayer',
    method: 'GET',
    params
  })
}

export function getGameTeamConfirmed(params) {
  return request({
    url: '/bmmatch/GetBMGameTeamConfirmed',
    method: 'GET',
    params
  })
}
export function adminGetBMGameSupervisionReport(params) {
  return request({
    url: '/bmmatch/AdminGetBMGameSupervisionReport',
    method: 'GET',
    params
  })
}

export function updateGameTeamConfirmed(params, data) {
  return request({
    url: '/bmmatch/TeamConfirmAfterGame',
    method: 'POST',
    params,
    data
  })
}
export function updateBMGameSupervisionReport(params, data) {
  return request({
    url: '/bmmatch/AdminUpdateBMGameSupervisionReport',
    method: 'POST',
    params,
    data
  })
}

export function updateGameRefereeConfirmed(params, data) {
  return request({
    url: '/bmmatch/RefereeConfirmAfterGame',
    method: 'POST',
    params,
    data
  })
}

export function getGameSpecialRemark(params) {
  return request({
    url: '/bmmatch/AdminGetBMGameSpecialRemark',
    method: 'GET',
    params
  })
}
export function adminGetUnionMatchFields(params) {
  return request({
    url: '/bmmatch/AdminGetUnionMatchFields',
    method: 'GET',
    params
  })
}

export function adminGetUnionMatchFieldsGames(params) {
  return request({
    url: '/bmmatch/AdminGetUnionMatchFieldsGames',
    method: 'GET',
    params
  })
}
export function getUnionMatchFieldGameDateList(params) {
  return request({
    url: '/bmmatch/GetUnionMatchFieldGameDateList',
    method: 'GET',
    params
  })
}
export function adminGetUnionMatchFieldGameList(params) {
  return request({
    url: '/bmmatch/AdminGetUnionMatchFieldGameList',
    method: 'GET',
    params
  })
}

// S365 兼容：战表页面历史命名
export function getUnionMatchFieldGameList(params) {
  return request({
    url: '/bmmatch/GetUnionMatchFieldsGameList',
    method: 'GET',
    params
  })
}

export function updateGameSpecialRemark(params, data) {
  return request({
    url: '/bmmatch/AdminUpdateBMGameSpecialRemark',
    method: 'POST',
    params,
    data
  })
}